module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-label": "Epigraph"
    }
  }, [_c('blockquote', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epitxt"
  }, [_c('span', {
    attrs: {
      "aria-label": "page ix",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page x",
      "id": "page_x",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE UNIVERSE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt1"
  }, [_c('i', [_vm._v("is not required to be")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IN PERFECT HARMONY")])]), _vm._v(" "), _c('p', {
    staticClass: "epitxt1"
  }, [_c('i', [_vm._v("with human ambition.”")])]), _vm._v(" "), _c('p', {
    staticClass: "epinam"
  }, [_vm._v("—Carl Sagan")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79616d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781442450844/xhtml/epigraph.vue
// module id = 66
// module chunks = 0